module.exports = __webpack_public_path__ + "static/img/kqwxts.1b2d14e7.png";